import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../../../models/user';
import { UserService } from '../../permissions/user/user.service';

export const userResolver: ResolveFn<User> = (route): Observable<User> =>
	inject(UserService)
		.getUser();